import { get_native16zxqjg6lrtlz as get_native } from './NativeElement.commonHtml.mjs';
import { DriverActionException1ncfunkkb5qm9 as DriverActionException } from './DriverActionException.mjs';
import { awaitxmqwgrq6yfmw as await_0 } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Promise.mjs';
import { startsWith26w8qjqapeeq6 as startsWith } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { removePrefix279df90bhrqqg as removePrefix } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *driverScreenshot(_this__u8e3s4, $completion) {
  var tmp0_elvis_lhs = get_native(_this__u8e3s4).element_1;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw DriverActionException().new_com_lightningkite_kiteui_views_DriverActionException_z6tfwz_k$('Element not yet attached to DOM');
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var element = tmp;
  // Inline function 'kotlin.js.unsafeCast' call
  var resultPromise = import('https://esm.sh/modern-screenshot@4.4.39').then(function (mod) {
    return function (rootEl) {
      // Fix 1: Add temporary <style> with CSSOM rules as text
      var genStyle = document.querySelector('style[title="generated-css"]');
      var extraStyle = document.createElement('style');
      if (genStyle && genStyle.sheet) {
        var rulesText = [];
        for (var r = 0; r < genStyle.sheet.cssRules.length; r++) {
          rulesText.push(genStyle.sheet.cssRules[r].cssText.replace(/\s*!important/g, ''));
        }
        extraStyle.textContent = rulesText.join('\n');
      }
      document.head.appendChild(extraStyle); // Fix 2: Strip !important from static CSS rules in-place
      var restored = [];
      for (var s = 0; s < document.styleSheets.length; s++) {
        var sheet = document.styleSheets[s];
        if (sheet === extraStyle.sheet || (genStyle && sheet === genStyle.sheet))
          continue;
        try {
          for (var r = 0; r < sheet.cssRules.length; r++) {
            var rule = sheet.cssRules[r];
            if (rule.cssText && rule.cssText.indexOf('!important') !== -1) {
              var original = rule.cssText;
              var cleaned = original.replace(/\s*!important/g, '');
              restored.push({sheet: sheet, index: r, original: original});
              sheet.deleteRule(r);
              sheet.insertRule(cleaned, r);
            }
          }
        } catch (e) {
        }
      }
      var removedLinks = [];
      var links = document.querySelectorAll('link[rel="stylesheet"]');
      for (var i = 0; i < links.length; i++) {
        if (links[i].href && links[i].href.indexOf(location.origin) !== 0) {
          removedLinks.push({el: links[i], parent: links[i].parentElement, next: links[i].nextSibling});
          links[i].remove();
        }
      }
      void rootEl.offsetHeight;
      function restore() {
        extraStyle.remove();
        for (var i = restored.length - 1; i >= 0; i--) {
          try {
            restored[i].sheet.deleteRule(restored[i].index);
            restored[i].sheet.insertRule(restored[i].original, restored[i].index);
          } catch (e) {
          }
        }
        for (var i = 0; i < removedLinks.length; i++) {
          var l = removedLinks[i];
          if (l.next && l.next.parentNode === l.parent)
            l.parent.insertBefore(l.el, l.next);
          else
            l.parent.appendChild(l.el);
        }
      }
      return mod.domToPng(rootEl, {workerUrl: false, font: {skipFonts: true}}).then(function (result) {
        restore();
        return result;
      }).catch(function (err) {
        restore();
        throw err;
      });
    }(element);
  });
  var dataUrl = yield* await_0(resultPromise, $completion);
  var prefix = 'data:image/png;base64,';
  if (!startsWith(dataUrl, prefix)) {
    throw DriverActionException().new_com_lightningkite_kiteui_views_DriverActionException_z6tfwz_k$('Unexpected screenshot data URL format');
  }
  return removePrefix(dataUrl, prefix);
}
//region block: exports
export {
  driverScreenshot as driverScreenshotwnxd0hlj28c0,
};
//endregion

//# sourceMappingURL=DriverScreenshot.js.mjs.map
